import { render, staticRenderFns } from "./purchaseOrderLineDetail.vue?vue&type=template&id=61ff7824&scoped=true"
import script from "./purchaseOrderLineDetail.vue?vue&type=script&lang=js"
export * from "./purchaseOrderLineDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrderLineDetail.vue?vue&type=style&index=0&id=61ff7824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ff7824",
  null
  
)

export default component.exports